<template>
  <div class="accountSettings">
    <section id="leftPane">

      <h1>ドライバーの編集</h1>
      <p class="warningMessage" v-if="isWarning">!未入力の項目があります!</p>

      <div id="customIdInputArea">
        <h3 class="inputTitle">ID（省略可）</h3>
        <input type="text" placeholder="" v-model="customId">
      </div>

      <div id="nameInputArea">
        <h3 class="inputTitle">名前</h3>
        <input :class="{warned: (isWarning && !name)}" type="text" placeholder="" v-model="name">
      </div>

      <div id="mailInputArea">
        <h3 class="inputTitle">メールアドレス</h3>
        <input :class="{warned: (isWarning && !email)}" type="text" placeholder="" v-model="email">
      </div>

      <div id="passwordInputArea">
        <h3 class="inputTitle">パスワード</h3>
        <input type="text" placeholder="パスワードを変更するときだけ入力" v-model="password">
      </div>

      <div id="phoneInputArea">
        <h3 class="inputTitle">電話番号（省略可）</h3>
        <input type="text" placeholder="" v-model="phone">
      </div>

      <div>
        <h2 class="inputTitle" >車種（省略可）</h2>
        <select class="vehicleSelect" v-model="vehicleType" @change="onVehicleTypeChange($event)">
         <option value="" disabled selected>車種を選択してください</option>
          <option v-for="type in vehicleTypes" :value="type">
            {{ type }}
          </option>
        </select>
        <!--<p v-if="selected_driver_name">{{selected_driver_name}}</p>-->
      </div>

      <div>
        <button class="button" :class="{disabled: isButtonDisabled}" @click="editDriver">更新</button>
      </div>


      <div class="loadingBackground" v-if="isLoading">
        <div class="loadingDialog">
          <half-circle-spinner
            :animation-duration="1000"
            :size="60"
            :color="'#ffffff'"
          />
        </div>
      </div>

      <!-- Saving Error Modal -->
      <div class="modalBackground" v-if="error.modal" @click.self="closeErrorModal">
        <div class="modalDialog">
          <h5>{{error.message}}</h5>
          <div id="modalContent">
            <button class="button" @click="closeErrorModal">閉じる</button>
          </div>

        </div>
      </div>

    </section>
  </div>

</template>


<script >
  import {fbFunctions, auth, db, fb} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'

  export default {
    name: 'EditDriver',

    components: {
      HalfCircleSpinner
    },

    data () {
      return {
        originalCustomId: null,
        originalName: '',
        originalEmail: '',
        originalPhone: null,
        originalPassword: '',
        originalVehicleType: null,

        driverId: '',
        customId: null,
        name: '',
        email: '',
        password: '',
        phone:'',
        vehicleType: null,


        isLoading: false,

        /* 入力にエラーがあるかどうかのフラグ */
        isWarning: false,

        /* 車種のリスト */
        vehicleTypes: ['bike', 'car'],
        selected: null, //車種の選択がされているかどうかのフラグ。ここをさんこうにした→ https://codepen.io/getreworked/pen/eMPeMa?editors=1010#
        
        /* エラー表示 */
        error: {
          modal: false,
          message: ""
        }
      }
    },

    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },


      isButtonDisabled() {
        if(this.name !== this.originalName){
          return false
        }

        if(this.email !== this.originalEmail){
          return false
        }

        if(this.customId !== this.originalCustomId){
          return false
        }

        if(this.phone !== this.originalPhone){
          return false
        }

        if(this.password !== this.originalPassword){
          return false
        }

        if(this.vehicleType !== this.originalVehicleType){
          return false
        }
        return true
      }
    },

    methods: {


      async editDriver() {

        if(this.isButtonDisabled){
          console.log("button is disabled")

          /* 未入力チェック */
          if(!(this.name && this.email)){
            this.isWarning = true
          }
          return
        }

        this.isWarning = false


        let user = auth.currentUser;
        if(!user){
          //TODO: エラーを表示
          console.log('current user is null')
          return
        }

        //TODO: パスワードcheckをいれる

        try{
          this.isLoading = true

          console.log('updating driver of driverId=', this.driverId)

          var editDriver = fbFunctions.httpsCallable('editDriver');
          let result = await editDriver({
            id: this.driverId,
            email: this.email,
            //phoneNumber: '080-0000-0000',
            password: this.password,
            name: this.name,
          })

          // Read result of the Cloud Function.
          let newUserEmail = result.data.email
          let newUserName = result.data.name
          let newUserPassword = result.data.password
          console.log("driver account updated", newUserEmail, newUserName, newUserPassword)
        }catch(error) {

          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          //var details = error.details;


          if(code === 'already-exists'){
            //すでに同じemailのユーザーがいる。
            this.openErrorModal('このメールアドレスはすでに使われています')
          }else if (code === 'invalid-argument'){
            //パラメターがおかしい
            this.openErrorModal('アカウントの更新に失敗しました')
          }else{
            this.openErrorModal('アカウントの更新に失敗しました')
          }

          console.log('Error editing driver account:', code, message);

          this.isLoading = false
          return
        }

        try{
          var data = {name:this.name, email:this.email}
          if(this.phone) { data.phone = this.phone }
          if(this.customId) { data.customId = this.customId }
          if(this.vehicleType) { data.vehicleType = this.vehicleType }
          await db.collection('companies').doc(this.companyId).collection('drivers').doc(this.driverId).update(data)

          this.originalCustomId = this.customId
          this.originalEmail = this.email
          this.originalName = this.name
          this.originalPhone = this.phone
          this.originalPassword = this.password
          this.originalVehicleType = this. vehicleType
          //this.password = ''
        }catch (error) {
          console.log('Error editing the driver data:', error);
          this.openErrorModal('ドライバー情報の更新に失敗しました')
          this.isLoading = false
          return
        }

        this.isLoading = false

        await new Promise((resolve, reject) => {
          setTimeout(() => resolve(true), 500) // resolve
        })
        this.$router.go(-1)

      },

      onVehicleTypeChange(event) {
        let vehicleType = event.target.value
        if(vehicleType){
          this.vehicleType = vehicleType
        }
      },

      openErrorModal(errorDetails) {
        this.error.message = errorDetails
        this.error.modal= true
      },
      closeErrorModal() {
        this.error.modal = false
      },

    },

    mounted() {

      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        //this.getDrivers()

        //this.driver = this.driverProps

        this.driver = {

        }

        this.driverId = this.$route.query.id
        this.customId = this.$route.query.customId
        this.name = this.$route.query.name
        this.email = this.$route.query.email
        this.phone = this.$route.query.phone
        this.vehicleType = this.$route.query.vehicleType

        this.originalCustomId = this.customId
        this.originalName = this.name
        this.originalEmail = this.email
        this.originalPhone = this.phone
        this.originalVehicleType = this.vehicleType

        var i;
        for (i = 0; i < this.vehicleTypes.length; i++) {
          let vehicle = this.vehicleTypes[i]
          console.log("vehicleType", this.vehicleType)
          if(this.vehicleType && this.vehicleType === vehicle){
            this.selected = vehicle
            break
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #leftPane {
    text-align: left;
    margin-left: 4em;
  }

  #leftPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  h2 {
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin-top: 40px;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0;
  }

  input {
    width: 300px;
    height: 35px;
    margin-top: 0;
  }


  #mailInputArea input {
    width: 400px;
  }

  .inputTitle {
    color: #5C5C5C;
    font-size: 20px;
    font-weight: lighter;
    margin-top: 2px;

  }


  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /* 未入力の項目の警告用スタイル */
  .warned {
    background-color: #F3C99F;
  }

  .warningMessage {
    color: #FF6B49;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
  }

  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border:2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }

  /* Error Modal CSS */
  .modalBackground{
    position:fixed;
    padding:0;
    margin:0;

    top:0;
    left:0;

    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.5);
  }

  .modalDialog {
    /* https://stackoverflow.com/a/14816807/1709287 */
    width: 420px;
    height: 150px;
    border-radius: 4px;
    position:absolute; /*it can be fixed too*/
    left:0; right:0;
    top:0; bottom:0;
    margin:auto;
    /*this to solve "the content will not be cut when the window is smaller than the content": */
    max-width:100%;
    max-height:100%;
    overflow:auto;
    background-color: white;
  }

  .modalDialog h5{
    color: #FF6B49;
    font-weight: normal;
    margin: 30px 0 30px 20px;
    text-align: center;
  }

  #modalContent{
    display:flex;
    align-items: center;
    justify-content: center;
  }

  #modalContent button{
    margin: 5px 12px;
    padding: 7px 15px;
  }

  @media(max-width: 400px) {

    #leftPane {
      text-align: center;
      margin: 0 auto 0 auto;
    }

    #leftPane h1{
      text-align: left;
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 39px;
      margin-left: 25px;
    }

    /* 未入力の項目の警告用スタイル */
    .warned {
      background-color: #F3C99F;
    }

    .warningMessage {
      color: #FF6B49;
      font-size: 15px;
      margin-top: 0;
      margin-bottom: 0;
    }

    .inputTitle {
      text-align: left;
      color: #5C5C5C;
      font-size: 15px;
      font-weight: lighter;
      margin-top: 2px;
      margin-left: 25px;
      margin-bottom: 0;
    }

    input {
      width: 86%;
      margin: 0 auto 0 auto;
      height: 28px;
      padding: 10px;
      border-style: solid;
      border-width: 1px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border:2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #mailInputArea input {
      width: 86%;
    }

    .button {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 25px;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }

    /* Error Modal モバイル対応 */
    .modalDialog {
      /* https://stackoverflow.com/a/14816807/1709287 */
      width: 90%;
    }

    .modalDialog h5{
      font-weight: normal;
      margin: 40px 10px 10px 10px;
    }


  }

</style>



// WEBPACK FOOTER //
// src/pages/EditDriver.vue